// @flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { type ActivityUser } from 'app/common/redux/reducers/activityItems';
import { Avatar, Box } from 'gestalt';

type Props = {
  hasOutline?: boolean,
  size?: 'sm' | 'md',
  user: ActivityUser,
};

const sizes = {
  sm: 24,
  md: 40,
};

function ActivityAvatar({ user, size = 'md', hasOutline }: Props) {
  const { first_name: name, image_medium_url: image, username } = user;
  return (
    <NavigateLink stopPropagation to={`/${username}/`}>
      <Box position="relative" width={sizes[size]} height={sizes[size]}>
        <Avatar size={size} src={image} name={name || username || ''} outline={hasOutline} />
      </Box>
    </NavigateLink>
  );
}

export default ActivityAvatar;
